import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";
import _ from "lodash";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import { Session } from "src/pages/Sessions";
import { z } from "zod";
import { Button } from "./ui/button";
import { AlcDrawer, DrawerTitle } from "./ui/drawer";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "./ui/form";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";

const FormSchema = z.object({
  name: z.string().min(1).max(50),
  public: z.boolean(),
});

const SessionEditDrawer = ({
  children,
  session,
  mutate,
}: {
  session: Session;
  children: any;
  mutate?: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const user = useSelector((state: any) => state.user);

  const [editing, setEditing] = useState(false);

  const form = useForm<z.infer<typeof FormSchema>>({
    mode: "onBlur",
    resolver: zodResolver(FormSchema),
    defaultValues: {
      name: session.name,
      public: session.public || false,
    },
  });

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    setEditing(true);
    data = _.omitBy(data, (v) => v === null || v === "");
    const response = await axios
      .patch(
        `${process.env.REACT_APP_API_URL}/sessions/${session._id}`,
        {
          name: data.name,
          public: data.public,
        },
        { headers: { Authorization: user.token } }
      )
      .catch(() => {
        toast.error(
          "Nastala chyba. Seanci se nepodařilo upravit. Zkontroluj připojení k internetu."
        );
      });
    if (response) {
      if (mutate) mutate();
      setIsOpen(false);
    }
    setEditing(false);
  }

  return (
    <AlcDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      trigger={children}
      asChild
      header={
        <>
          <DrawerTitle className="text-center">Úprava seance</DrawerTitle>
        </>
      }
    >
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Název</FormLabel>
                <Input
                  type="text"
                  autoComplete="name"
                  id="name"
                  maxLength={50}
                  {...field}
                />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="public"
            render={({ field }) => (
              <FormItem className="flex flex-row items-center justify-between rounded-lg border p-3 shadow-sm">
                <div className="space-y-0.5">
                  <FormLabel>Veřejné</FormLabel>
                  <FormDescription>
                    Tvoji přátelé budou moci vidět tuto seanci.
                  </FormDescription>
                </div>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <div className="py-4">
            <Button type="submit" className="w-full" disabled={editing}>
              {editing ? "Ukládání" : "Uložit seanci"}
            </Button>
          </div>
        </form>
      </Form>
    </AlcDrawer>
  );
};

export default SessionEditDrawer;
